const API_BASE_URL = process.env.REACT_APP_AUTH_API_URL + '/api/Authentication';

const AuthenticationService = {
  // Update user profile
  updateProfile: async userData => {
    const token = AuthenticationService.getToken();
    if (!token) return { success: false, message: 'No token found.' };
    try {
      const response = await fetch(`${API_BASE_URL}/update-user-info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(userData),
      });
      const data = await response.json();
      if (response.ok) {
        return { success: true, user: data };
      } else {
        return { success: false, message: data.message || 'Update failed.' };
      }
    } catch (e) {
      return { success: false, message: 'Network error.' };
    }
  },
  // Login user
  login: async (email, password) => {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });
    return response.json();
  },

  // Register new user
  register: async ({
    username,
    email,
    password,
    phone,
    city,
    address,
    postalCode,
    country,
    firstName,
    lastName,
  }) => {
    const structuredAddressDto = new StructuredAddressDto(
      address,
      city,
      country,
      postalCode
    );
    const user = new RegisterUserRequest(
      email,
      email,
      password,
      structuredAddressDto,
      phone,
      firstName,
      lastName
    );

    const response = await fetch(`${API_BASE_URL}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });

    const data = await response.json();
    if (response.ok) {
      return { success: true, message: data.message };
    } else {
      return {
        success: false,
        message: data.errors || data.message || 'Registration failed.',
      };
    }
  },

  // Save access token to localStorage
  saveToken: accessToken => {
    try {
      localStorage.setItem('accessToken', accessToken);
    } catch (e) {}
  },

  // Get access token from localStorage
  getToken: () => {
    return localStorage.getItem('accessToken');
  },

  // Validate token by calling /me endpoint
  validateToken: async () => {
    const token = AuthenticationService.getToken();
    if (!token) return null;
    try {
      const response = await fetch(`${API_BASE_URL}/me`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) return null;
      return response.json(); // Should return user info (e.g., email)
    } catch (e) {
      return null;
    }
  },
};

export default AuthenticationService;

export class RegisterUserRequest {
  constructor(
    username,
    email,
    password,
    address = null,
    phone = '',
    firstName = '',
    lastName = ''
  ) {
    this.username = username;
    this.email = email;
    this.password = password;
    this.address = address;
    this.phone = phone;
    this.firstName = firstName;
    this.lastName = lastName;
  }
}

export class StructuredAddressDto {
  constructor(
    streetAddress = '',
    city = '',
    country = '',
    zipCode = '',
    state = ''
  ) {
    this.streetAddress = streetAddress;
    this.city = city;
    this.country = country;
    this.zipCode = zipCode;
    this.state = state;
  }
}
